import { type ApiKeyCreateInput, type ApiKeyPublic } from '@carsfinders/contracts';

import { API_BASE_URL } from '../../lib/env';
import { apiFetch } from '../../lib/api';

/**
 * Admin feed-key API (Phase 14 — B2B portal). Calls api-node directly:
 *   GET    /api/admin/feed/keys        → { keys }
 *   POST   /api/admin/feed/keys        → { success, apiKey (raw, ONCE), key }
 *   DELETE /api/admin/feed/keys/:id    → { success, revoked }
 */
export interface FeedKeysListResponse {
	keys: ApiKeyPublic[];
}

export interface IssueFeedKeyResponse {
	success: boolean;
	/** The raw secret key — shown ONCE, never returned again. */
	apiKey: string;
	key: ApiKeyPublic;
}

export function fetchFeedKeys(): Promise<FeedKeysListResponse> {
	return apiFetch<FeedKeysListResponse>('admin/feed/keys');
}

export function issueFeedKey(input: ApiKeyCreateInput): Promise<IssueFeedKeyResponse> {
	return apiFetch<IssueFeedKeyResponse>('admin/feed/keys', { method: 'POST', body: input });
}

export function revokeFeedKey(id: string): Promise<{ success: boolean; revoked: string }> {
	return apiFetch(`admin/feed/keys/${id}`, { method: 'DELETE' });
}

/** Absolute URL to the public OpenAPI spec for the partner feed. */
export const FEED_OPENAPI_URL = `${API_BASE_URL}/docs/feed`;
